export default {
  Lang: {
    de: 'Deutsch',
    en: 'Englisch'
  },
  Action: {
    add: 'Hinzufügen',
    edit: 'Bearbeiten',
    remove: 'Entfernen',
    close: 'Schließen',
    select: 'Auswählen',
    save: 'Speichern',
    saving: 'Wird gespeichert',
    send: 'Senden',
    confirmSelection: 'Auswahl bestätigen',
    change: 'Ändern',
    changeSelection: 'Auswahl ändern',
    next: 'Weiter',
    prev: 'Zurück',
    finish: 'Fertig',
    search: 'Suche',
    usePrevious: 'Vorangegangene Auswahl übernehmen',
    download: 'Herunterladen',
    removeAttachment: 'Datei löschen?',
    archive: 'Archivieren',
    unarchive: 'Wiederherstellen',
    confirmPayment: 'Zahlungspflichtig bestellen',
  },
  Password: {
    'lengthDesc': 'Mindestens {x} Zeichen',
    'lowerDesc': 'Mindestens ein Buchstabe',
    'upperDesc': 'Mindestens ein Großbuchstabe',
    'digitDesc': 'Mindestens eine Zahl',
    'specialDesc': 'Mindestens ein Sonderzeichen',
    'low': 'Sehr schwach',
    'weak': 'Schwach',
    'medium': 'Ausreichend',
    'strong': 'Gut',
    'extra-strong': 'Ausgezeichnet',
    'confirmationNoMatch': 'Das Passwort und dessen Bestätigung stimmen nicht überein',
  },
  Common: {
    start: 'Start',
    date: 'Datum',
    name: 'Name',
    noSelection: 'Keine Auswahl',
    creationdate: 'Erstellungsdatum',
    lastmodified: 'Letzte Änderung',
    status: 'Status',
    color: 'Farbe',
    settings: 'Einstellungen',
    masterdata: 'Stammdaten',
    masterdataSaved: 'Stammdaten wurden gespeichert',
    amount: 'Betrag',
    description: 'Beschreibung',
    notice: 'Bemerkung',
    item: 'Artikel',
    itemNum: 'Artikel Nr.',
    itemName: 'Artikelname',
    itemPrice: 'Artikelpreis',
    quantity: 'Anzahl',
    singlePrice: 'Einzelpreis',
    discount: 'Nachlass',
    rebate: 'Rabatt',
    vat: 'MwSt.',
    total: 'Gesamt',
    misc: 'Sonstiges',
    orderPrice: 'Bestellpreis',
    annotation: 'Anmerkung',
    accountDetails: 'Kundendaten',
    customerNum: 'Kundennummer',
    salutation: 'Anrede',
    firstname: 'Vorname',
    lastname: 'Nachname',
    company: 'Firma',
    email: 'E-Mail',
    contact: 'Anschrift',
    address: 'Adresse',
    postalcode: 'PLZ',
    city: 'Stadt',
    country: 'Land',
    taxDetails: 'Steuerdaten',
    vatId: 'USt.-ID Nr.',
    noEntries: 'Keine Einträge',
    showAll: 'Alle anzeigen',
    languageSettings: 'Spracheinstellungen',
    showXtoYentries: 'Zeige {x} bis {y} Ergebnisse',
    showXtoYofZentries: 'Zeige {x} bis {y} von {z} Ergebnissen',
    error: 'Fehler',
    errorSavingMasterdata: 'Stammdaten konnten nicht gespeichert werden.',
    errorIncomplete: 'Formular unvollständig',
    errorFieldMissing: '{field} muss ausgefüllt sein',
    errorUploadInvalidResp: 'Ungültige Server-Antwort. Bitte versuchen Sie es erneut oder wenden Sie sich an unseren Support.',
    required: 'Wert erforderlich',
    loading: 'Werden geladen...',
    phone: 'Telefon',
    phone2: 'Telefon 2',
    cancelled: 'Storno',
  },
  Units: {
    C62: 'Stk',
    GRM: 'g'
  },
  Dashboard: {
    title: 'Dashboard'
  },
  Addresses: {
    title: 'Adressen',
    add: 'Neue Adresse',
    addressMain: 'Hauptanschrift',
    addressBilling: 'Rechnungsanschrift',
    addressShipping: 'Lieferanschrift',
    confirmRemove: 'Wollen Sie den Kontakt wirklich entfernen?',
    errorLoad: 'Adressen konnten nicht geladen werden.',
    errorRemove: 'Adresse konnte nicht gelöscht werden.'
  },
  EditAddress: {
    title: 'Neue Adresse',
    errorTypeTitle: 'Bitte legen Sie einen Adresstypen fest.',
    errorTypeText: 'Die Anschrift muss eine Liefer- und/oder eine Rechnungsanschrift sein.',
    errorCreate: 'Adresse konnte nicht angelegt werden.',
    errorUpdate: 'Adresse konnte nicht aktualisiert werden.',
    shipping: 'Lieferungen',
    useForShippingNo: 'Nicht als Lieferanschrift verwenden',
    useForShippingYes: 'Als Lieferanschrift verwenden',
    useForShippingDefault: 'Als Standard-Lieferanschrift verwenden',
    billing: 'Rechnungen',
    useForBillingNo: 'Nicht als Rechnungsanschrift verwenden',
    useForBillingYes: 'Als Rechnungsanschrift verwenden',
    useForBillingDefault: 'Als Standard-Rechnungsanschrift verwenden'
  },
  Packages: {
    title: 'Pakete'
  },
  Projects: {
    title: 'Projekte',
    loading: 'Projekte werden geladen',
    currentProjects: 'Aktuelle Projekte',
    showAll: 'Alle Projekte anzeigen',
    noProjects: 'Keine Projekte',
    add: 'Neues Projekt',
    projectNumber: 'Projekt Nr.',
    projectName: 'Projektname',
    projectType: 'Projekttyp',
    statusAll: 'Alle Projekte',
    statusOpen: 'Offene Projekte',
    statusOrdered: 'Bestellte Projekte',
    errorNoName: 'Bitte geben Sie einen Projektnamen ein',
    errorCreate: 'Projekt konnte nicht angelegt werden.',
    errorCouldNotLoad: 'Projekte konnten nicht geladen werden'
  },
  ProjectDetails: {
    title: 'Projektdetails',
    loading: 'Projekt wird geladen',
    saving: 'Projekt wird gespeichert',
    saved: 'Projekt gespeichert',
    alertOrdered: 'Projekt bestellt:',
    openOrder: 'Bestellung öffnen',
    alertReference: 'Dieses Projekt ist mit einem anderen Projekt verknüft:',
    openProject: 'Projekt öffnen',
    toothSelection: 'Zahnauswahl',
    noConstruction: 'Keine Konstruktion festgelegt!',
    editConstruction: 'Kontruktion bearbeiten',
    materialSelection: 'Materialauswahl',
    estimatedDelivery: 'Vorauss. Lieferdatum',
    missingMaterial: 'Materialauswahl fehlt',
    missingAttachments: 'Fehlende Anhänge',
    addStl: 'STL hinzufügen',
    openCart: 'Zum Warenkorb',
    emptyCart: 'Warenkorb leer',
    shippingType: 'Versandart',
    construction: 'Konstruktion',
    stlUpload: 'STL Upload',
    attachments: 'Anhänge',
    cart: 'Warenkorb',
    addItem: 'Artikel hinzufügen',
    orderProject: 'Projekt bestellen',
    statusNotOrdered: 'Noch nicht bestellt',
    statusOrdered: 'Bestellt',
    statusExpired: 'Frist abgelaufen',
    statusReview: 'Zur Freigabe',
    statusApproved: 'Freigegeben',
    statusRejected: 'Zurückgewiesen',
    errorNoProjectnum: 'Keine gültige Projektnummer übergeben',
    addons: 'Zusatzartikel',
    orderOptions: 'Weitere Bestelloptionen',
    approval: 'Freigabe',
    reject: 'Vorschlag ablehnen',
    approve: 'Vorschlag annehmen',
    confirmRejection: 'Wollen sie diesen Vorschlag wirklich ablehnen?',
    confirmApproval: 'Wollen sie diesen Vorschlag wirklich annehmen?',
    warningRejectMessage: 'Bitte geben Sie im Bemerkungsfeld einen Begründung für Ihre Ablehnung ein!',
    hasBeenRejected: 'Der Projektvorschlag wurde abgelehnt!',
    hasBeenApproved: 'Der Projektvorschlag wurde angenommen!',
    selectorLayersIncomplete: 'Bitte überprüfen Sie Ihre Auswahl',
    supplierName: 'Dienstleister',
    errorCouldNotLoad: 'Projekt konnte nicht geladen werden.',
    errorInvalidServerResponse: 'Ungültige Serverantwort.',
    errorCouldNotSave: 'Projekt konnte nicht gespeichert werden.',
    removing: 'Projekt wird entfernt',
    removed: 'Projekt entfernt',
    errorCouldNotRemove: 'Projekt konnte nicht entfernt werden.',
    orderSuccessful: 'Bestellung {order} erfolgreich!',
    costs: 'Projektkosten',
    calculatingPrices: 'Preise werden berechnet',
    errorCouldNotCalcDuedate: 'Fälligkeitsdatum konnte nicht berechnet werden.',
    confirmSave: 'Wollen Sie das Projekt speichern?',
    clickToMakeSelection: 'Bitte zum Beginnen der Auswahl in ein Feld klicken',
    secondClickToCompleteSelection: 'Zum Abschließen der Auswahl in eins der markierten Felder klicken',
    messages: 'Chat',
    OK: 'OK',
    UK: 'UK',
    allCategories: 'Alle Kategorien',
  },
  Orders: {
    title: 'Bestellungen',
    loading: 'Bestellungen werden geladen',
    currentOrders: 'Aktuelle Bestellungen',
    openOrder: 'Bestellung öffnen',
    showAll: 'Alle Bestellungen anzeigen',
    noOrders: 'Keine Bestellungen',
    orderNum: 'Auftrag Nr.',
    projectRef: 'Projektreferenz',
    extRef: 'Externe Referenz',
    statusAll: 'Alle Bestellungen',
    statusNotOrdered: 'Noch nicht bestellt',
    statusReceived: 'Eingegangen',
    statusReceivedDescr: 'Bestellung wird geprüft',
    statusInProgress: 'In Bearbeitung',
    statusInProgressDescr: 'Ihre Bestellung wird bearbeitet',
    statusInProduction: 'In Produktion',
    statusInProductionDescr: 'Fertigung hat begonnen',
    statusOnHold: 'Gehalten',
    statusCancelled: 'Storniert',
    statusCancelledDescr: 'Ihre Bestellung wurde storniert',
    statusClosed: 'Geschlossen',
    statusCompleted: 'Abgeschlossen',
    statusCompletedDescr: 'Ihre Bestellung ist vollständig',
    statusInvoicedCancelled: 'Teilberechnet / Storniert',
    statusPartlyDelivered: 'Teilgeliefert',
    statusPartlyDeliveredCancelled: 'Teilgeliefert / Storniert',
    statusPartlyDeliveredClosed: 'Teilgeliefert / Geschlossen',
    statusDelivered: 'Versendet',
    statusDeliveredDescr: 'Ihre Bestellung wurde versendet',
    statusInvoiced: 'Abgerechnet',
    statusReadyForPickup: 'Abholbereit',
    errorCouldNotLoad: 'Bestellungen konnten nicht geladen werden'
  },
  OrderDetails: {
    title: 'Bestelldetails',
    deliveryNote: 'Lieferschein',
    loading: 'Bestellung wird geladen',
    trackingNum: 'Tracking Nr.',
    manufacturingStatus: 'Fertigungsstatus',
    trackingAndBilling: 'Tracking und Abrechnung',
    creatingOrder: 'Bestellung wird erstellt',
    orderProject: 'Projekt bestellen',
    placeOrder: 'Bestellung abschließen',
    acceptTerms: 'Ich habe die <a href="{termsUrl}" target="_blank">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiert.',
    errorNoOrderNum: 'Keine gültige Bestellnummer übergeben',
    errorCouldNotLoad: 'Bestellung konnte nicht geladen werden',
    priceNobleMetal1: 'Der Endgültige Produktpreis ist bei Edelmetallen vom endgültigen Gewicht abhängig.',
    priceNobleMetal2: 'Bitte prüfen Sie hierzu Ihren Lieferschein, sobald der Auftrag abgeschlossen ist.',
    files: 'Dateien',
    allCategories: 'Alle Kategorien'
  },
  Messages: {
    title: 'Nachrichten',
    noMessages: 'Keine Nachrichten',
    errorCouldNotLoad: 'Nachrichten konnte nicht geladen werden',
    writeSomething: 'Schreiben Sie was...',
    errorSendingMessage: 'Nachricht konnte nicht gesendet werden.'
  },
  Configurator: {
    selectIndication: 'Indikation wählen',
    changeMaterial: 'Material ändern',
    selectTooth: 'Bitte wählen Sie einen Zahn',
    showToothNumbers: 'Zahnnummern anzeigen',
    toothSelection: 'Zahnauswahl',
    setProductProps: 'Produkteigenschaften festlegen',
    selectProduct: 'Produkt wählen',
    fileXofY: 'Datei {x} von {y}',
    calcPrice: 'Preise werden berechnet',
    uploadStl: 'STL hochladen',
    stlCount: 'Einheitenanzahl der obigen STL',
    stlCountTooltip: 'Bitte Einheitenanzahl der STL-Datei angeben, z.B. 3 Einheiten bei dreigliedriger Brücke',
    oneUnit: 'Eine Einheit',
    nUnits: '{n} Einheiten',
    removeJawSelection: 'Wollen sie die bestehende Auswahl in diesem Kiefer entfernen?',
    invalidTeethInRange: 'Zahnnummer {0} liegt außerhalb der Zahnreihe {1} bis {2}.',
    invalidRange: 'Die Zahnreihe {0} bis {1} ist ungültig. Start und Ende müssen auf dem gleichen Kiefer liegen.',
    invalidTeethNumber: 'Zahnnummer {0} ist ungültig.',
    transferSettings: 'Wollen Sie diese Auswahl für eine Zahnreihe vornehmen?',
    clickOnConnectTooth: 'Klicken Sie auf den letzten Zahn der Reihe.'
  },
  Invoices: {
    title: 'Rechnungen',
    loading: 'Rechnungen werden geladen',
    invoiceNum: 'Rechnung Nr.',
    monthlyStatement: 'Monatsaufstellung',
    statusReceived: 'Eingegangen',
    statusOpen: 'Offen',
    statusHold: 'Gehalten',
    statusCancelled: 'Storniert',
    statusClosed: 'Geschlossen',
    statusPartlyPaid: 'Teilbezahlt',
    statusPartlyPaidCancelled: 'Teilbezahlt / Storniert',
    statusPartlyPaidClosed: 'Teilbezahlt / Geschlossen',
    statusPaid: 'Bezahlt'
  },
  File: {
    name: 'Dateiname',
    hash: 'Dateihash',
    size: 'Dateigröße',
    messageUpload: 'Zum Upload klicken oder Datei auf das Feld ziehen',
    allFilesSameMaterial: 'Alle Dateien haben das gleiche Material',
    preparingData: 'Daten werden vorbereitet',
    sendingData: 'Daten werden übermittelt',
    processingData: 'Daten werden verarbeitet',
    errorUpload: 'Es ist ein Fehler aufgetreten. Die Datei konnte leider nicht hochgeladen werden.',
    errorCouldNotList: 'Dateien konnten nicht geladen werden.',
    errorCouldNotLoad: 'Datei konnte nicht geladen werden.',
    errorCouldNotDelete: 'Datei konnte nicht entfernt werden.',
    waiting: 'Warten...',
    errorFileCountLimit: 'Bestimmungen bezüglich der Anzahl der Dateien werden nicht eingehalten',
    errorFileSizeLimit: 'Bestimmungen bezüglich der Dateigröße werden nicht eingehalten',
    errorFileNameInvalid: 'Bestimmungen bezüglich des Dateinamens werden nicht eingehalten',
    errorFileTypeInvalid: 'Bestimmungen bezüglich des Dateityps werden nicht eingehalten',
  },
  Login: {
    username: 'E-Mail oder Kundennummer',
    password: 'Passwort',
    passwordOld: 'Altes Passwort',
    passwordNew: 'Neues Passwort',
    passwordConfirm: 'Neues Passwort bestätigen',
    passwordSaved: 'Passwort gespeichert',
    recover: 'Passwort zurücksetzen',
    checkEmailForRecoverLink: 'Ihre neuen Zugangsdaten wurden Ihnen per E-Mail zugesendet',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Passwort wiederholen',
    change: 'Passwort ändern',
    back: '< Zurück zur Anmeldung',
    login: 'Login',
    logout: 'Logout',
    enterPwd: 'Bitte geben Sie ein Passwort ein',
    invalidUserOrPwd: 'Ungültiger Benutzername/Passwort',
    errorCouldNotUpdate: 'Passwort konnte nicht gespeichert werden.',
    errorPasswordNoMatch: 'Passwörter stimmen nicht überein.',
    errorOldPassword: 'Das alte Passwort ist falsch.',
    errorNoSession: 'Keine Benutzersession gefunden. Bitte melden Sie sich an.',
    enterSameConfirmPwd: 'Die beiden Passwörter stimmen nicht überein. Bitte in beiden Feldern das selbe Passwort eintragen',
  },
  Infothek: {
    title: 'Infothek',
    loading: 'Laden...',
    noContent: 'In der von Ihnen ausgewählten Sprache sind leider keine Inhalte verfügbar',
  },
  CookieConsent: {
    header: 'Wir respektieren Ihre Privatsphäre',
    message: 'Diese Website verwendet Cookies, um Ihnen die bestmögliche Erfahrung zu gewährleisten. Integrierte Drittanbieter können diese Informationen mit weiteren Daten zusammenführen. Sofern nicht anders angegeben, enthalten die Cookies personenbezogene Daten. Durch Klicken auf "Alle wählen und schließen" erklären Sie sich mit der Verwendung dieser Cookies einverstanden und speichern Ihre Einstellungen. Alternativ können Sie auswählen, welche spezifischen Cookies Sie zulassen möchten und Ihre Einstellungen durch Klicken auf "Auswahl bestätigen" speichern. Weitere Informationen sowie die Widerspruchsmöglichkeit finden Sie in unseren <a href="https://www.dentadesk.com/datenschutzerklaerung">Datenschutzhinweisen</a>.',
    dismiss: 'Verstanden!',
    allow: 'Cookies zulassen',
    deny: 'Ablehnen',
    link: 'Erfahren Sie mehr',
    policy: 'Cookie-Richtlinie',
    acceptSelection: 'Auswahl bestätigen',
    acceptAll: 'Alle wählen und schließen',
    analytics: 'Analytics (2 Jahre Speicherdauer)',
    required: 'Notwendig (unbegrenzte Speicherdauer)',
    services: 'Dienste',
    servicesDescription: {
      cookieconsent: 'Speichert die Einwilligung des Nutzers zu Cookies für diese Webseite (keine personenbezogenen Daten)',
      laravel: 'Speichert den Zustand der Sitzung über mehrere Seitenanfragen hinweg',
      XSRFTOKEN: 'Speichert ein Sicherheitstoken für Formular- und Datei-Versand (keine personenbezogenen Daten)',
      cfduid: 'Genutzt vom Dienstanbieter Cloudflare, um vertraulichen Datenverkehr zu identifizieren',
      sentry: 'Bereitgestellt von sentry.io zur Fehleranalyse',
      googleAnalytics: 'Speichert allgemeine Nutzungsstatistiken',
      youtube: 'Speichert Nutzungsstatistiken beim Ansehen von eingebetteten Videos'
    }
  },
};
